var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81898 0.333986C8.94009 0.310546 9.0651 0.310546 9.1862 0.333986L16.9995 1.89664C17.437 1.98258 17.7534 2.36934 17.7534 2.8147C17.7534 3.26005 17.437 3.64681 16.9995 3.73276L14.0031 4.33438V6.56506C14.0031 9.32705 11.7646 11.5656 9.00259 11.5656C6.2406 11.5656 4.00211 9.32705 4.00211 6.56506V4.33438L2.12692 3.95934V6.50256L2.74026 9.56536C2.77542 9.74897 2.72854 9.94039 2.61134 10.0849C2.49415 10.2295 2.31444 10.3154 2.12692 10.3154H0.8768C0.689282 10.3154 0.513483 10.2334 0.392378 10.0849C0.271272 9.93649 0.224393 9.74897 0.263459 9.56536L0.8768 6.50256V3.6976C0.50567 3.56868 0.251739 3.21708 0.251739 2.8147C0.251739 2.36934 0.568176 1.98258 1.00572 1.89664L8.81898 0.333986ZM4.62326 13.1165C5.03346 12.9837 5.47491 13.1321 5.77181 13.4485L8.54552 16.3981C8.79164 16.6598 9.20965 16.6598 9.45576 16.3981L12.2295 13.4485C12.5264 13.1321 12.9678 12.9837 13.378 13.1165C15.9173 13.933 17.7534 16.3082 17.7534 19.1171C17.7534 19.7812 17.2143 20.3164 16.5541 20.3164H1.45107C0.790854 20.3164 0.251739 19.7773 0.251739 19.1171C0.251739 16.3082 2.08786 13.933 4.62326 13.1165Z",
    fill: "#5063EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3ef1687eecd4db7a5c6bb2bd8fbbca76.svg";
export { ForwardRef as ReactComponent };